export default "/images/vendor/@coreui/icons/svg/flag/cif-sz.svg?e37bd2bfa4c280785a1f83cd08f38bc9";